import { USER_SERVICE } from "../consts";

export const EMPLOYEE_API = `${USER_SERVICE}users`;
